import LinearProgress from "@mui/material/LinearProgress";
import { useSelector } from "react-redux";
import "./Spinner.scss";

export default function LoadingSpinner() {
  const spinnerActive = useSelector((state: any) => state.spinner);

  if (!spinnerActive) {
    return null;
  }

  return (
    <div className="loading-progress" role="progressbar" aria-label="Loading">
      <LinearProgress color="primary" />
    </div>
  );
}
